import { render, staticRenderFns } from "./PErrorPage.vue?vue&type=template&id=77ae3624&scoped=true&"
import script from "./PErrorPage.vue?vue&type=script&lang=ts&"
export * from "./PErrorPage.vue?vue&type=script&lang=ts&"
import style0 from "./PErrorPage.vue?vue&type=style&index=0&id=77ae3624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ae3624",
  null
  
)

export default component.exports